var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-bg-orange-100 tw-border-l-4 tw-border-orange-200 tw-text-orange-dark tw-p-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"tw-font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }